<template lang="pug">
  el-collapse
    el-collapse-item(
      v-for="item in infoList"
      :key="item.title"
      :title="item.title"
      :descList="item.descList")
      div(class="collapseDesc"
        v-for="desc in item.descList"
        :key="desc") {{desc}}
      slot(:name="item.name")
</template>

<script>
import CollapseItem from './collapseItem'
export default {
  name: 'collapseInfo',
  components: {
    CollapseItem
  },
  props: {
    infoList: {
      type: Array,
      default: []
    }
  },
  computed: {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?6000dace